import type { ComponentInit } from "@scripts/registry";
import { createTrack } from "@scripts/track";

const TRACK = "[data-fa-featured-video-track]";
const ITEM = "[data-fa-featured-video-item]";
const PREV = '[data-fa-featured-video-arrow="prev"]';
const NEXT = '[data-fa-featured-video-arrow="next"]';

export const initFeaturedVideo: ComponentInit = (root) => {
	const track = root.querySelector<HTMLElement>(TRACK);
	const prev = root.querySelector<HTMLElement>(PREV);
	const next = root.querySelector<HTMLElement>(NEXT);

	if (!track || !prev || !next) return;

	return createTrack({ track, prev, next, item: ITEM });
};
